<template>
  <v-btn small rounded color="primary" :loading="loading" @click="submit()" :disabled="!(has_done_form && !done_form_is_partial)" >{{text}}</v-btn>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState({
      oneActionPlan: state => state.ActionPlan.oneActionPlan
    }),
    done_form_is_partial(){
      return this.oneActionPlan.data.attributes.done_form_is_partial
    },
    has_done_form() {
      return this.oneActionPlan.data.attributes.done_form_id ? true : false;
    },
    text() {
      return this.has_done_form ? "Ver Formulário" : this.done_form_is_partial? "Envio parcial" : "Espontâneo";
    }
  },
  methods: {
    submit() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$router.push({
          name: "OneDoneForm",
          params: { id: this.oneActionPlan.data.attributes.done_form_id }
        });
      }, 1000);
    }
  }
};
</script>